<div>
  <div class="app-footer">
    <div class="app-footer-content cf-flex-column cf-gap-8">
      <div class="app-footer-content-row cf-flex-row">
        <a><img src="assets/images/acticon_logo.svg" /></a>
      </div>
      <div class="cf-flex-row cf-gap-10 mat-subtitle-2">
        <a class="app-footer-item mat-subtitle-2" href="{{ 'UI.Common.Cookies.Url' | translate }}" target="_blank">{{
          'UI.Common.Cookies.Text' | translate
        }}</a>
        <a class="app-footer-item mat-subtitle-2" href="{{ 'UI.Common.TermsOfService.Url' | translate }}" target="_blank">{{
          'UI.Common.TermsOfService.Text' | translate
        }}</a>
        <span class="app-footer-item mat-subtitle-2">
          {{ 'Common.Version' | translate }} {{ 'Common.CurrentVersionNumber' | translate }}
        </span>
      </div>
    </div>
  </div>
</div>
